import React, { createContext, useContext } from 'react';

// 1. Definisikan objek tema kustom Anda
const customTheme = {
  colorLightBlue: '#87CEFA', // Light Sky Blue
};

// 2. Buat React Context dengan tema sebagai nilai default
const CustomThemeContext = createContext(customTheme);

// 3. Buat Provider Component
export const CustomThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <CustomThemeContext.Provider value={customTheme}>
      {children}
    </CustomThemeContext.Provider>
  );
};

// 4. Buat hook kustom untuk kemudahan penggunaan
export const useCustomTheme = () => {
  return useContext(CustomThemeContext);
};
